var map = {
	"./facebook-image": 10,
	"./facebook-image.jpg": 10,
	"./favicon": 11,
	"./favicon.svg": 11,
	"./ico-amazingservice": 12,
	"./ico-amazingservice.svg": 12,
	"./ico-email": 13,
	"./ico-email.svg": 13,
	"./ico-free-delivery": 14,
	"./ico-free-delivery.svg": 14,
	"./ico-medium-larger-business": 15,
	"./ico-medium-larger-business.svg": 15,
	"./ico-message": 16,
	"./ico-message.svg": 16,
	"./ico-national-brand": 17,
	"./ico-national-brand.svg": 17,
	"./ico-print-expertise": 18,
	"./ico-print-expertise.svg": 18,
	"./ico-small-business": 19,
	"./ico-small-business.svg": 19,
	"./ico-telephone": 20,
	"./ico-telephone.svg": 20,
	"./ico-testimonials": 21,
	"./ico-testimonials.svg": 21,
	"./logo-pds-rgb": 22,
	"./logo-pds-rgb.svg": 22,
	"./logo-pds-white": 23,
	"./logo-pds-white.svg": 23,
	"./testimonials": 24,
	"./testimonials.jpg": 24
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34;